// extracted by mini-css-extract-plugin
export default {"home_header":"Home_home_header__idb6B","icon":"Home_icon__-ILK7","buttons":"Home_buttons__a63H7","detail":"Home_detail__+lE80"};